import * as React from 'react';
import { datePickerDayOfWeekHeaderStyle, datePickerCellStyles } from './DatePickerStyles';
import { getStartDayOfWeek, getLocalizedDaysOfWeek } from '../../utils/Date';

interface DatePickerDayOfWeekHeaderProps {
  showWeekNumbers?: boolean;
}

class DatePickerDayOfWeekHeader extends React.Component<DatePickerDayOfWeekHeaderProps, {}> {
  private getDayOfWeekHeader(): string[] {
    const startDayOfWeek = getStartDayOfWeek(!!this.props.showWeekNumbers);
    const dayOfWeek: string[] = getLocalizedDaysOfWeek(startDayOfWeek);
    if (this.props.showWeekNumbers) {
      dayOfWeek.unshift('#');
    }
    return dayOfWeek;
  }

  public render(): JSX.Element {
    const weekOfDayHeader: JSX.Element[] = [];
    this.getDayOfWeekHeader().forEach((header, index) => {
      const style = this.props.showWeekNumbers && index === 0 ?
        datePickerCellStyles.isoWeekNumColHeader :
        datePickerCellStyles.dayOfWeekColHeader;
      weekOfDayHeader.push(
        <div key={index} style={style} role='columnheader'>
          {header}
        </div>
      );
    });
    return (
      <div style={datePickerDayOfWeekHeaderStyle} role='rowheader'>
        {weekOfDayHeader}
      </div>
    );
  }
}

export { DatePickerDayOfWeekHeaderProps, DatePickerDayOfWeekHeader };
